import { createContext, useState, useContext, useEffect } from "react";
import {
  login as loginService,
  logout as logoutService,
} from "../servicios/auth.service";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  // Cargar usuario desde localStorage al iniciar
  useEffect(() => {
    const storedUser = localStorage.getItem("userData");
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
    setIsLoading(false); // Marcar como cargado una vez que terminemos
  }, []);

  // 📌 Usar el servicio de login
  const login = async (email, password) => {
    try {
      const userData = await loginService(email, password);
      setUser(userData); // Actualizar estado
      return userData; // Devolver datos por si es necesario en el componente
    } catch (error) {
      throw error; // Permitir manejo de error en el frontend
    }
  };

  // 📌 Usar el servicio de logout
  const logout = () => {
    logoutService();
    setUser(null);
  };

  // 📌 Bloquear la app hasta que `isLoading` termine
  if (isLoading) {
    return <div>Cargando...</div>; // Puedes poner un Spinner de Material-UI aquí
  }

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};
